import get from 'lodash/get'
import { i18n } from '@/main'
import { mergeLangMessages } from './chat-config'

class StringUtils {
  ellipsis (str, maxLength) {
    return str.length > maxLength ? str.substring(0, maxLength - 3) + '...' : str
  }

  updateLocaleMessages (langOverride, serverLang) {
    const currentLocaleMessages = get(i18n.messages, i18n.locale, {})
    i18n.setLocaleMessage(i18n.locale, mergeLangMessages(currentLocaleMessages, serverLang, langOverride))
  }
}

export default new StringUtils()
